import React from 'react'
import PropTypes from 'prop-types'
import { interpolate } from 'utils'

// Who accepted, and the first course each recommends. A summary only: the full
// card, the other courses and the messaging live on the request page, so this
// has no links and no actions of its own.
export default function AcceptedTeachersSummary({ teachers, moreCount, t }) {
  if (!teachers || teachers.length === 0) return null

  return (
    <div className="mt-3">
      <ul className="space-y-2">
        {teachers.map((teacher, index) => (
          <li key={`${teacher.name}-${index}`} className="rounded-lg border border-stone-200 p-3">
            <p className="font-medium text-stone-900">
              <span data-teacher-name>{teacher.name}</span>
              {teacher.team_name && <span className="ml-2 text-sm font-normal text-stone-500">{teacher.team_name}</span>}
            </p>
            {teacher.first_course && (
              <>
                <p className="mt-0.5 text-sm text-stone-600">
                  {teacher.first_course.name} · {teacher.first_course.price_label}
                  {teacher.more_courses_count > 0 && ' '}
                  {teacher.more_courses_count > 0 && (
                    <span className="whitespace-nowrap text-stone-500">
                      {interpolate(teacher.more_courses_count === 1 && t.more_courses_one ? t.more_courses_one : t.more_courses, { count: teacher.more_courses_count })}
                    </span>
                  )}
                </p>
                {teacher.first_course.fit_note && (
                  <p className="mt-1 text-sm text-stone-800">{interpolate(t.course_fits, { note: teacher.first_course.fit_note })}</p>
                )}
              </>
            )}
          </li>
        ))}
      </ul>
      {moreCount > 0 && (
        <p className="mt-2 text-sm text-stone-500">{interpolate(t.more_teachers, { count: moreCount })}</p>
      )}
    </div>
  )
}

AcceptedTeachersSummary.propTypes = {
  teachers: PropTypes.arrayOf(PropTypes.object),
  moreCount: PropTypes.number,
  t: PropTypes.shape({ more_teachers: PropTypes.string, more_courses: PropTypes.string, more_courses_one: PropTypes.string, course_fits: PropTypes.string })
}

AcceptedTeachersSummary.defaultProps = {
  teachers: [],
  moreCount: 0,
  t: {}
}
